import React from 'react';
import { Calendar } from 'modules/dealActivity/calendar';
import { PageContainer } from 'components/shared/Page/PageContainer';

export const CalendarPage = () => {
  return (
    <PageContainer title="Calendar">
      <Calendar />
    </PageContainer>
  );
};
